import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { ManageStaffService } from './manage-staff.service';
import { CommonService } from '../../shared/services/common/common.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-manage-staff',
  templateUrl: './manage-staff.component.html',
  styleUrls: ['./manage-staff.component.scss'],
  imports: [CommonModule, SharedModule],
})
export class ManageStaffComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['serialNo', 'name', 'email', 'phone', 'role'];
  staffDataSource: MatTableDataSource<any>;
  isLoading = false;
  
  // Pagination settings
  pageSize = 10;
  currentPage = 1;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private staffService: ManageStaffService,
    private commonService: CommonService,
    private router: Router
  ) {
    this.staffDataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.loadStaffList();
  }

  ngAfterViewInit() {
    this.staffDataSource.paginator = this.paginator;
    this.staffDataSource.sort = this.sort;
  }

  loadStaffList(): void {
    this.isLoading = true;
    // Get user details from login response stored in localStorage
    const userData = this.commonService.getUserDetails();
    
    // Extract the required fields from user data

    const loginID = userData.userId ;
    const userType = userData.userType 
    const role = userData.userRole ;
    
    // Check if required values are present
    // if (!loginID || !userType || !role) {
    //   console.error('Missing required user data. Redirecting to login.');
    //   // Redirect to login if user data is missing
    //   // this.router.navigate(['/auth/login']);
    //   return;
    // }
    
    // Call the service with the dynamic values
    this.staffService.getStaffList(
      loginID, 
      userType, 
      this.currentPage, 
      this.pageSize, 
      role
    ).subscribe({
      next: (response) => {
        if (response && response.statusCode === 200) {
          this.staffDataSource = new MatTableDataSource(response.data.response);
          setTimeout(() => {
            if (this.paginator) {
              this.staffDataSource.paginator = this.paginator;
            }
          });
        } else {
          console.error('API Error:', response);
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('API Error:', error);
        this.isLoading = false;
      }
    });
  }

  // Handle page change event from paginator
  onPageChange(event: any): void {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.loadStaffList();
  }

  editStaff(staff: any): void {
    // Implement your edit logic here
  }

  deleteStaff(id: number): void {
    // Implement your delete logic here
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.staffDataSource.filter = filterValue.trim().toLowerCase();

    if (this.staffDataSource.paginator) {
      this.staffDataSource.paginator.firstPage();
    }
  }
}